import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '~/components/base/Dialog/Dialog'
import './ValuePopup.scss'

const MAX_VALUE_LENGTH = 40

export const getTruncatedValue = (value, maxLength = MAX_VALUE_LENGTH) => {
  if (value === null || value === undefined) return value
  const stringValue = String(value)
  return stringValue.length > maxLength ? `${stringValue.slice(0, maxLength)}...` : stringValue
}

export const ValuePopupText = ({ value, className = '', onClick = () => {} }) => {
  if (value === null || value === undefined || value === '') return value
  return (
    <span className={`admin-panel__link ${className}`} onClick={onClick}>
      {getTruncatedValue(value)}
    </span>
  )
}

export const ValuePopup = ({ title, value, open, onClose = () => {} }) => (
  <Dialog className="value-popup" open={open} onClose={onClose}>
    <DialogTitle className="value-popup__title">{title}</DialogTitle>
    <DialogContent className="value-popup__content">
      <div className="value-popup__message">{value}</div>
    </DialogContent>
  </Dialog>
)
